
import React from 'react';
import { Button } from "@/components/ui/button";
import { useAuth } from '@/hooks/useAuth';

interface EmptyStateProps {
  message: string;
  action?: React.ReactNode;
  showDefaultAction?: boolean; // Add option for default action
}

const EmptyState: React.FC<EmptyStateProps> = ({ message, action, showDefaultAction = false }) => {
  const { userProfile } = useAuth();
  // Safely check if the user is a journalist
  const isJournalist = userProfile?.user_role === 'journalist';

  return (
    <div className="col-span-full text-center py-8 text-muted-foreground">
      <p className="mb-4">{message}</p>
      {action || (showDefaultAction && isJournalist && (
        <Button asChild variant="outline">
          <a href="/dashboard/content">View your own articles</a>
        </Button>
      ))}
    </div>
  );
};

export default EmptyState;
